export const byteToMb = (bytes: number) => Math.round(bytes / (1024 * 1024));

export const byteToKb = (bytes: number) => Math.round(bytes / 1024);


export function dateToInputFormat(date: string | null | undefined) {
    if(date) {
        let _date = new Date(date);
        let _month = _date.getMonth() + 1 > 10 ? _date.getMonth() + 1 : `0${_date.getMonth() + 1}`

        return `${_date.getFullYear()}-${_month}-${_date.getDate()}`
    }
    return ""
}

export function fileToBase64(value: File) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(value);
    });
}

export function base64ToFile(base64String: string, filename: string) {
    const arr = base64String.split(",");
    //@ts-ignore
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime })
}